import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { Helmet } from 'react-helmet';

//css
import './shopping.css';

//Icones
import LojasIcon from '../../../images/svg/shopping-bag.svg';
import WIFIIcon from '../../../images/svg/wifi.svg';
import LanchonetesIcon from '../../../images/svg/fast-food.svg';
import EstacionamentoIcon from '../../../images/svg/parking.svg';
import CinemaIcon from '../../../images/svg/video-camera.svg';
import AcademiaIcon from '../../../images/svg/workout.svg';

//imagens
import SNS1 from '../../../images/shopping1.jpg';
import SNS2 from '../../../images/shopping2.jpg';

const items_shopping = [
	{
		icone: LojasIcon,
		primary: '67',
		secondary: 'Lojas',
	},
	{
		icone: WIFIIcon,
		primary: 'WIFI',
		secondary: 'Gratuito',
	},
	{
		icone: LanchonetesIcon,
		primary: '15',
		secondary: 'Restaurantes',
	},
	{
		icone: EstacionamentoIcon,
		primary: '1000',
		secondary: 'Vagas de Estacionamento',
	},
	{
		icone: CinemaIcon,
		primary: '4',
		secondary: 'Salas de Cinema',
	},
	{
		icone: AcademiaIcon,
		primary: '1',
		secondary: 'Academia',
	},
]

export default class OShopping extends React.Component {
    render() {
        return (
				<div className="app_content_page" >
					<Helmet>
						<title>O Shopping</title>
						<meta name="description" content="Helmet application" />
					</Helmet>
					<div className="app_content_page__title_body" >
						<div className="title_body__content" >
							<Typography variant="h5" >O Shopping</Typography>
						</div>
					</div>
					<div className="app_content_page__row" >
						<Grid container spacing={16} >
							<Grid item md={6} >
								<img src={SNS1} alt="" width="100%" />
							</Grid>
							<Grid item md={6} className="row__history_text" >
								<Typography variant="h5" gutterBottom>O shopping que conhece você!</Typography>
								<Typography variant="body1" gutterBottom>Com 15 mil metros quadrados de área, o Shopping Norte Sul foi fundado no ano de 2003, por um grupo de empresários do ramo imobiliário e serviços que enxergaram a possibilidade de um empreendimento em um dos bairros que se tornara promissor em Vitória e que necessitava de um centro de compras, lazer e serviços. Com 110 lojas, o mall é dividido em três pisos e recebe cerca de 55 mil pessoas semanalmente, e conta com diversos segmentos para atender ao público como acessórios, artigos em geral, brinquedos, calçado e moda esporte, cosméticos e estética, eletroeletrônicos, informática, livros e papelaria, moda praia e íntima, vestuário geral, vestuário infantil, vestuário masculino.</Typography>
								<Typography variant="body1" gutterBottom>Atualmente, o shopping se revitalizou, renovou sua fachada e conta com diversas novidades, entre elas, a inovação das salas de cinema, sob a responsabilidade de uma nova rede de distribuição de filmes, a Cinemagic e ainda uma academia de ginástica, a Wellness Club, academia que se preocupa com o bem estar de seus alunos e oferece um espaço diferenciado e moderno para o exercício e prática do bem estar. No shopping, a academia será toda envidraçada, onde os alunos poderão ter a vista panorâmica do bairro de Jardim Camburi. </Typography>
							</Grid>
							<Grid item md={12} >
								<Grid container spacing={16} >
									{items_shopping.map((i,k) => <Grid key={k} item xs={12} md={2} >
										<div className="object_shopping_item" >
											<img src={i.icone} alt="icone" />
											<div>
												<Typography variant="h4" >{i.primary}</Typography>
												<Typography variant="body2" >{i.secondary}</Typography>
											</div>
										</div>
									</Grid>)}
								</Grid>
							</Grid>
							<Grid item md={6} className="row__history_text" >
								<Typography variant="body1" gutterBottom >Conta com uma Praça de Alimentação onde são oferecidas o melhor da gastronomia local e nacional e ainda há espaço para  a cultura, com oferecimento de música ao vivo e encontros literários, além de shows, exposições, etc.</Typography>
								<Typography variant="body1" gutterBottom >Com o atual advento da tecnologia, o Shopping Norte Sul é pioneiro em oferecer serviço Wi-Fi gratuito para seus clientes, e ainda um espaço para os mesmos utilizarem suas máquinas, como notebooks, tablets, etc. No segmento serviço, o Shopping Norte Sul conta com caixas eletrônicos de diversas agências bancárias, além de Correios, farmácia, oficina de costura, casa lotérica e revistaria.</Typography>
								<Typography variant="body1" gutterBottom >A valorização do bairro Jardim Camburi se revela a cada quadra do bairro e a evolução do comércio local está lado a lado com o boom imobiliário. Assim, o Shopping Norte Sul caminha junto com a comunidade se atualizando cada vez mais para oferecer o que há de melhor no segmento de compras e serviços.</Typography>
							</Grid>
							<Grid item md={6} >
								<img src={SNS2} alt="" width="100%" />
							</Grid>
						</Grid>
					</div>
					<div className="app_content_page__map" >
						<div className="map__header_title_row" >
							<div className="header_title_row__container" >
								<Typography variant="h5" >Nossa localização</Typography>
							</div>
						</div>
						<div>
							<iframe width={'100%'} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3743.1836570133546!2d-40.27431548508026!3d-20.251216586424693!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xb81855ea941d4f%3A0x78448d82e3e3de3b!2sShopping+Norte+Sul!5e0!3m2!1spt-BR!2sbr!4v1562609247331!5m2!1spt-BR!2sbr" height={'450px'} frameBorder={'0'} style={{border:'none'}} allowFullScreen></iframe>
						</div>
					</div>
				</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/web/pages/oshopping/index.js